import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { i18n } from './i18n';
import { loadAccountLocale } from './i18n/account';
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

const app = createApp(App);

// Create an event bus instance
const eventBus = {
  listeners: {},
  $on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  },
  $emit(event, ...args) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => {
        callback(...args);
      });
    }
  },
};

app.use(Toast, {
  position: POSITION.BOTTOM_CENTER,
  timeout: 6000,
  // timeout: false, // for testing
  draggable: false,
  maxToasts: 10
});

const toast = {
  clearToasts() {
    app.config.globalProperties.$toast.clear();
  },
  success(message) {
    this.clearToasts();
    app.config.globalProperties.$toast.success(message, {});
  },
  error(message) {
    this.clearToasts();
    app.config.globalProperties.$toast.error(message, {
      timeout: false, // Keep the toast until manually dismissed
    });
  },
  info(message) {
    this.clearToasts();
    app.config.globalProperties.$toast.info(message, {
      timeout: 10000,
    });
  },
  warning(message) {
    this.clearToasts();
    app.config.globalProperties.$toast.warning(message, {
      timeout: 10000,
    });
  },
};

app.provide('toast', toast);
app.provide('eventBus', eventBus); // Provide eventBus at the root level
app.use(i18n);
app.use(router);
// app.use(Toast, {
//   position: POSITION.BOTTOM_LEFT, // Setting the global default position
//   // timeout: false,
//   timeout: 5000,
// });
// Wait for the router's initial navigation to resolve before the first render: otherwise
// components mount once with $route still unresolved (e.g. App.vue can't yet tell a public
// page like /login from a protected one), firing requests that assume a logged-in user.
// Show the app once the language of the logged in user is known (see src/i18n/account.js)
Promise.all([router.isReady(), loadAccountLocale()]).finally(() => app.mount('#app'));
